import { AuthEndpoints, RequestMethods, useRequest } from '@shared/index';
import type {
  LoginRequestParams,
  LoginResponse,
  LoginResponseError,
} from '@shared/types';

export const useLogin = ({ username, password }: LoginRequestParams) => {
  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    LoginRequestParams,
    LoginResponse,
    LoginResponseError
  >({
    params: {
      key: 'login',
      method: RequestMethods.POST,
      url: AuthEndpoints.LOGIN,
      request: {
        username,
        password,
      },
      fetchManual: true,
    },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
